<template>
	<div 
		ref="ocrEdit"
		class="full-container"
	>
		<div class="full-top-wrap">
			OCR Template Edit
		</div>
		<div class="full-center-wrap">
			<!-- 좌측 카테고리 영역 -->
			<form @submit.prevent="doValidation()" style="height: 100%;">
				<!-- 우측 상단 Template Name 영역 -->
				<div class="survey-name-ocr">
					<div class="survey-name-label">
						Template Name
					</div>
					<div class="survey-name-input">
						<input
							type="text"
							name="ocrName"
							v-model="ocrTemplate.ocrName"
							v-validate="'required'"
							data-vv-as="ocrName"
							class="input-crud"
							:class="(errors.has('ocrName') || isDuplicate ? 'input-crud-error' : '')"
							:placeholder="(errors.has('ocrName') ? '* ' + errors.first('ocrName') : 'Please enter the OCR Template Name.')"
							@input="doDuplicateCheck($event.target.value)"
						/>
						<div v-if="isDuplicate" class="duplicate-balloon">
							* Template Name is duplicated.
						</div>
					</div>
					<div class="survey-name-label">
						Sample Image
					</div>
					<div class="survey-name-input">
						<input
							type="file"
							name="myfile"
							ref="myfile"
							v-validate="'required'"
							enctype="multipart/form-data"
							multiple="false"
							hidden
							@change="upload($event.target.name, $event.target.files)"
							@drop="upload($event.target.name, $event.target.files)"
						/>
						<input
							ref="fileName"
							style="border-radius: 0px;"
							type="text"
							class="file-input-crud elipsis-input"
							:title="fileName"
							:value="fileName"
							readonly
						/>
						<button type="button" class="file-btn-crud" @click.stop="openUploader()">
							Upload
						</button>
					</div>
					<div class="survey-name-label">
						Description
					</div>
					<div class="survey-name-input" style="grid-column: 2 / 5">
						<input
							type="text"
							name="description"
							v-model="ocrTemplate.description"
							v-validate="'required'"
							data-vv-as="Procedure Name"
							class="input-crud"
							:placeholder="(errors.has('description') ? '* ' + errors.first('description') : 'Please enter the Description.')"
						/>
					</div>
					<div class="survey-name-label">
						Page Name
					</div>
					<div class="survey-name-input table-set" style="grid-column: 2 / 5">
						<input
							type="text"
							name="pageName"
							v-model="items.pageName"
							v-validate="'required'"
							data-vv-as="Procedure Label"
							class="input-crud"
							disabled
						/>
					</div>
				</div>
				<!-- 중앙 Survey 생성 영역 -->
				<div
					class="survey-center-ocr"
				>
					<div
						ref="uploadFile"
						v-if="!isDrawImage"
						class="survey-left-ocr"
						@click.stop="openUploader()"
					>
						+Upload File
					</div>
					<div
						ref="imageViewer"
						v-if="isDrawImage"
						class="survey-left-ocr"
					>
						<div class="pdf-container">
							<div class="canvas-container" :class="{'canvas-active': selectedOcrField}">
								<!-- <img :src="imageUrl" class="image-viewer" ref="imageViewer" /> -->
								<canvas 
									ref="drawingCanvas" 
									class="drawing-canvas"
									loading="lazy"
									@mousedown="startDrawing"
									@mousemove="draw"
									@mouseup="stopDrawing"
									@mouseleave="stopDrawing"
								></canvas>
							</div>
							<div 
								class="drawing-tools" 
								v-if="isDrawingMode || (selectedOcrField && selectedOcrField.isFocused)"
								:style="{
									top: toolsPosition.y + 'px',
									left: toolsPosition.x + 'px',
									opacity: toolsPosition.visible ? 1 : 0,
									transition: 'opacity 0.2s ease-in-out'
								}"
							>
								<button 
									type="button" 
									class="drawing-tool" 
									@click="saveDrawing" 
									title="Save"
								>
									<span class="tool-icon save-icon">✓</span>
								</button>
								<button 
									type="button" 
									class="drawing-tool" 
									@click="deselectOcrField"
									title="Cancel"
								>
									<span class="tool-icon cancel-icon">✕</span>
								</button>
							</div>
							<!-- <div class="canvas-controls" v-if="selectedOcrField">
								<button type="button" class="canvas-control-btn" @click="deselectOcrField">
									<span>Exit Drawing Mode</span>
								</button>
							</div> -->
						</div>
					</div>
					<div
						class="survey-right-ocr"
					>
						<div
							class="field-spec-header"
						>
							Field Specification
						</div>
						<div
							class="field-spec-sub"
						>
							Field Type
						</div>
						<div
							class="field-type-list"
						>
							<div
								class="field-type-btn"
								@click.stop="openPageSelectModal('square')"
							>
								<div
									class="field-type-img-1"
								>
									<div class="field-type-img-sub">
										A
									</div>
									<div class="field-type-img-sub" style="border-left: none;">
										B
									</div>
								</div>
								<div>
									+Field Add 1
								</div>
							</div>
							<div
								class="field-type-btn"
								@click.stop="openPageSelectModal('divided')"
							>
								<div
									class="field-type-img-2"
									style="border: none;"
								>
									<div class="field-type-img-sub">
										A
									</div>
									<div class="field-type-img-sub">
										B
									</div>
								</div>
								<div>
									+Field Add 2
								</div>
							</div>
							<div
								class="field-type-btn"
								@click.stop="openPageSelectModal('check')"
							>
								<div
									class="field-type-img-3"
								>
								✓
								</div>
								<div>
									+Field Add 3
								</div>
							</div>
						</div>
						<ul class="ocr-field-list">
							<li
								v-for="(ocrFieldItem, index) in ocrFieldList"
								:key="index"
								class="ocr-field-item"
								:class="{ 'selected': selectedOcrField && selectedOcrField.fieldName === (ocrFieldItem.fieldName || ocrFieldItem[0].fieldName || ocrFieldItem[1].fieldName) && selectedOcrField.pageNo === (ocrFieldItem.pageNo || ocrFieldItem[0].pageNo || ocrFieldItem[1].pageNo) }"
								@click="ocrFieldItem.ocrFieldType ? selectOcrField(ocrFieldItem) : selectOcrDividedField(ocrFieldItem)"
							>
								<div class="ocr-field-title">
									<div class="ocr-field-serial">
										<span>Field {{ index + 1 }} [{{ ocrFieldItem.ocrFieldType ? ocrFieldItem.ocrFieldType : (ocrFieldItem[0].ocrFieldType ?? "") }}]</span>
									</div>
									<div class="orc-field-icon">
										<button 
											type="button"
											class="btn-edit edit-icon"
											@click.stop="editAnnotation(ocrFieldItem)"
										></button>
										<button
											type="button"
											class="btn-delete"
											@click.stop="deleteOcrField(index)"
										></button>
									</div>
								</div>
								<div
									v-if="ocrFieldItem.ocrFieldType ? ocrFieldItem.ocrFieldType !== 'divided' : ocrFieldItem[0].ocrFieldType !== 'divided'"
									class="ocr-field-content">
									<div class="ocr-field-category">
										<p class="ocr-field-text">
											Field Name
										</p>
									</div>
									<div class="ocr-field-box">
										<p class="ocr-field-text">
											<input
												type="text"
												class="input-crud"
												v-model="ocrFieldItem.fieldName"
												:placeholder="'Field Name ' + (index + 1)"
												@input="updateFieldName(ocrFieldItem)"
											/>
										</p>
									</div>
								</div>
								<ul
									v-if="ocrFieldItem.ocrFieldType ? ocrFieldItem.ocrFieldType === 'divided' : ocrFieldItem[0].ocrFieldType === 'divided'"
								>
								<li
										v-for="(ocrField, idx) in ocrFieldItem"
										:key="idx"
										class="ocr-field-content">
										<div class="ocr-field-category">
											<p class="ocr-field-text">
												{{ String.fromCharCode(65 + idx) }} Field Name
											</p>
										</div>
										<div class="ocr-field-box">
											<p class="ocr-field-text">
												<input
													type="text"
													class="input-crud"
													v-model="ocrField.fieldName"
													:placeholder="'Field Name ' + (idx + 1)"
													@click.stop=""
													@input="updateFieldName(ocrField)"
												/>
											</p>
										</div>
									</li>
								</ul>
								<div
									v-if="ocrFieldItem.ocrFieldType === 'check'"
									class="ocr-field-content"
								>	
									<div class="ocr-field-category">
										<p class="ocr-field-text">
											Value
										</p>
									</div>
									<div class="ocr-field-box">
										<p class="ocr-field-text">
											<select
												ref="checkValueSelect"
												name="checkValue"
												class="select-crud"
												:class="errors.has('checkValue') ? 'input-crud-error' : ''"
												v-model="ocrFieldItem.checkValue"
												v-validate="'required'"
												@click.stop=""
												@change.stop=""
											>
												<option value="" disabled>-- Select --</option>
												<option v-for="(checkOption, index) in ocrFieldItem.checkOptions" :key="index" :value="checkOption.checkValue">
													{{ checkOption.checkOption }}
												</option>
											</select>
										</p>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</form>
		</div>
		<div class="full-bottom-wrap">
			<button
				v-if="workAccessCheck('PROCEDURE CREATE') && !(projectStateCd == '4' || projectStateCd == '3')"
				type="button"
				class="btn-save fright"
				@click.stop="doSave()"
			>
				Save
			</button>
			<button
				type="button"
				class="btn-cancel fright"
				@click.stop="doCancel()"
				style="margin-right: 10px;"
			>
				Cancel
			</button>
		</div>
		<DefaultValue v-if="isDefaultValue" :defaultField="defaultField" :defaultCellId="defaultCellId"/>
		<OcrPageSelect v-if="isOcrPageSelect" :param="ocrFieldType" @ocr-page-view="openPageViewModal()" @close="isOcrPageSelect = false" />
		<OcrPageView v-if="isOcrPageView" :param="paramSigleCreate" @close="isOcrPageView = false" @ocr-field-save="ocrFieldSave" :ocrFieldList="ocrFieldList" />
	</div>
</template>

<script>
import axios from "axios";
import EventBus from "@/script/EventBus.js";

import DefaultValue from '@/components/project/procedure/DefaultValue.vue';
import OcrPageSelect from "@/components/project/ocr/modal/OcrPageSelect.vue";
import OcrPageView from "@/components/project/ocr/modal/OcrPageView.vue";

export default {
	name: "OcrEdit",
	components: {
		DefaultValue,
		OcrPageSelect,
		OcrPageView,
	},
	created() {
		this.logger.debug(this, "created()");
		this.items.projectNo = this.$route.params.projectNo;
		this.items.pageNo = this.$route.params.pageNo;
		this.items.ocrNo = this.$route.params.ocrNo;
		this.selectOcrTemplate();
		this.selectSortOrder();
		this.selectFieldList();
		this.selectPageList();
		this.getAccessList('PAGE');
		this.getProjectStateCd();
		
		// OCR 페이지 뷰 이벤트 리스너 추가
		EventBus.$on("ocr-page-view", this.openPageViewModal);
		EventBus.$on("ocr-field-save", this.ocrFieldSave);
	},
	beforeDestroy() {
		// 컴포넌트가 파괴되기 전에 이벤트 리스너 제거
		EventBus.$off("ocr-page-view", this.openPageViewModal);
		EventBus.$off("ocr-field-save", this.ocrFieldSave);
		EventBus.$off("keydown", this.handleEscKey);
	},
	mounted() {
		window.addEventListener('keydown', this.handleEscKey);
	},
	watch: {
		isDrawImage(newVal) {
			if (newVal) {
				this.$nextTick(() => {
					this.initializeCanvas();
				});
			}
		},
	},
	data() {
		return {
			toolsPosition: {
				x: 0,
				y: 0,
				visible: false
			},
			items: {},
			ocrTemplate: {},
			isInit: false,
			searchForm: {},
			fieldList: [],
			fieldCloseList: [],
			pageList: [],
			selectedPageList: [],
			surveyItemList: [],
			defaultField: [],
			defaultCellId: [],
			isTypingEdit: false,
			tableRow: 0,
			tableCol: 0,
			tableData: {},
			columnInfo: {},
			rowInfo: {},
			tableDrag: {
				isDrag: false,
				startId: "",
				endId: ""
			},
			clipBoard: {},
			preview: {
				isPreview: false,
				cellId: "",
			},
			dragData: {
				isDrag: false,
				position: {
					top: "",
					left: "",
				},
				mouseX: "",
				offsetY: "",
				fieldData: {},
			},
			// 상태 확인 데이터
			isTyping: false,
			isDuplicate: false,
			isDefaultValue: false,
			accessList: [],
			projectStateCd: "",
			repeatYn: "",
			// input 동적 데이터
			fileName : "(100MB, Formats:PDF)",
			ocrFile: null,
			ocrFieldType: "",
			isOcrPageSelect: false,
			isOcrPageView: false,
			ocrFieldList: [],
			ocrFieldListLength: 0,
			imageInfo: {
				imageUrl: "",
				imageWidth: 0,
				imageHeight: 0,
			},
			isDrawImage: false,
			imageObj: null,
			isDrawing: false,
			isDrawingMode: false,
			isEditMode: false,
			selectedOcrField: null,
			startX: 0,
			startY: 0,
			rectangle: null,
			canvasActive: false,
			parsedData: {},
		};
	},
	props: {
		value: {
				type: Array,
				default: function() {
					return [];
				},
			},
	},
	computed: {
		// OCR 페이지 뷰 모달의 상태를 확인하는 computed 속성
		isOcrPageViewModalOpen() {
			return this.isOcrPageView;
		},
		usedQuestionNo: function() {
			let usedQuestionNo = this.surveyItemList.map(
				(item) => {
					return item.questionNo;
				}
			);
			return usedQuestionNo;
		}
	},
	methods: {
		selectFieldList() {
			this.logger.debug(this, "selectFieldList()");
			this.searchForm.projectNo = this.$route.params.projectNo;
			axios
				.post(this.config.contextRoot + "/procedure/questionGroupList.do", this.searchForm)
				.then((response) => {
					this.fieldList = response.data;
					for(let g = 0 ; g < this.fieldList.length ; g++)
					{
						for(let q = 0 ; q < this.fieldList[g].questionList.length ; q++)
						{
							for(let f = 0 ; f < this.fieldList[g].questionList[q].fieldList.length ; f++)
							{
								if(this.fieldList[g].questionList[q].fieldList[f].fieldTypeCd == "09")
								{
									this.fieldList[g].questionList[q].fieldList[f].calculate = "";
								}
								this.fieldList[g].questionList[q].fieldList[f].duplicateYn = "N";
							}
						}
					}
					this.$nextTick(function () {
						setTimeout(function() {
							EventBus.$emit("project-loading", false);
						}, 400)
					});
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		selectPageList() {
			this.logger.debug(this, "selectPageList()");
			axios
				.post(this.config.contextRoot + "/page/selectList.do", {projectNo: this.items.projectNo, searchCategory: "ALL"})
				.then((response) => {
					this.pageList = response.data.pageList;
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		selectSortOrder() {
			this.logger.debug(this, "selectSortOrder()");
			axios
				.post(this.config.contextRoot + "/procedure/selectSortOrder.do", {pageNo: this.items.pageNo})
				.then((response) => {
					this.$set(this.items, "procSortOrder", response.data.procSortOrder);
					this.$nextTick(function () {
						// this.$validator.validateAll();
					});
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		fieldTypeName(questionItem){
			var fieldTypeCd = "";
			if(questionItem.fieldList.length > 0){
				fieldTypeCd = questionItem.fieldList[0].fieldTypeCd;
			}
			if(fieldTypeCd=="01"){
				return "type_01";
			}
			else if(fieldTypeCd=="02"){
				return "type_02";
			}
			else if(fieldTypeCd=="03"){
				return "type_03";
			}
			else if(fieldTypeCd=="04"){
				return "type_04";
			}
			else if(fieldTypeCd=="05"){
				return "type_05";
			}
			else if(fieldTypeCd=="06"){
				return "type_06";
			}
			else if(fieldTypeCd=="07"){
				return "type_07";
			}
			else if(fieldTypeCd=="08"){
				return "type_08";
			}
			else if(fieldTypeCd=="09"){
				return "type_09";
			}
			else if(fieldTypeCd=="10"){
				return "type_10";
			}
			else if(fieldTypeCd=="11"){
				return "type_11";
			}
			else if(fieldTypeCd=="12"){
				return "type_12";
			}
			else {
				return "";
			}
		},
		foldField(questionGroupNo) {
			this.logger.debug(this, "foldField(questionGroupNo)");
			let index = this.fieldCloseList.indexOf(questionGroupNo);
			if(index >= 0)
			{
				this.fieldCloseList.splice(index, 1);
			}
			else
			{
				this.fieldCloseList.push(questionGroupNo);
			}
		},
		keyupHandler(event) {
			this.logger.debug(this, "keyupHandler(event)");
			this.searchForm.searchText = event.target.value;
			this.searchForm.projectNo = this.$route.params.projectNo;
			if (event.keyCode == 13)
			{
				EventBus.$emit("project-loading", true);
				this.selectFieldList();
			}
		},
		infoBalloon(event) {
			this.logger.debug(this, "infoBalloon(event)");
			if(event.type == "focus")
			{
				this.isTyping = true;
			}
			else
			{
				this.$refs.typingBalloon.style.animation = "hideBalloon 0.3s ease-out both";
				setTimeout(function() {
					this.$refs.typingBalloon.style.animation = "";
					this.isTyping = false;
				}.bind(this), 310);
			}
		},
		doCancel() {
			this.logger.debug(this, "doCancel()");
			this.$confirm("Do you want to cancel the OCR template edit?","Question","question").then(() => {
				this.doClose();
			});
		},
		doClose() {
			this.logger.debug(this, "doClose()");
			this.$refs.ocrEdit.style.animation = "fadeOutUp 0.4s ease-in-out both";
			setTimeout(function() {
				let url = this.config.contextRoot + "/project/" + this.items.projectNo + "/ocr"
				if (this.$route.path !== url)
				{
					EventBus.$emit("project-loading", true);
					this.$router.push(url);
				}
			}.bind(this), 410);
		},
		getAccessList(category){
			axios
				.post(this.config.contextRoot + "/access/getCategoryPrivilegeList.do", {privilegeCategory: category})
				.then((response) => {
					this.accessList = response.data.privilegeList;
					this.accessList.forEach((obj) =>{
						this.workCheck(obj);
					})
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		async workCheck(obj){
			let item = {};
			item = {
				userId: sessionStorage.getItem("userId"),
				projectNo: this.$route.params.projectNo,
				privilegeTypeCd: obj.privilegeTypeCd,
				privilegeCategory: obj.privilegeCategory,
				privilegeName: obj.privilegeName
			}
			obj.isAccess = await this.$accessAuth(item);
		},
		workAccessCheck(name){
			for(let  i = 0; i < this.accessList.length; i++){
				if(this.accessList[i].privilegeName == name){
					return this.accessList[i].isAccess;
				}
			}
		},
		async selectOcrTemplate() {
			this.logger.debug(this, "selectOcrTemplate()");
			try {
				EventBus.$emit("project-loading", true);
				// Step 1: OCR 템플릿 조회
				const templateResponse = await axios.post(
					this.config.contextRoot + "/ocr/selectOcrTemplate.do",
					this.items
				);
				this.ocrTemplate = templateResponse.data.ocrTemplate;
				this.items.ocrName = this.ocrTemplate.ocrName;
				this.items.description = this.ocrTemplate.description;
				this.items.repeatCnt = this.ocrTemplate.repeatCnt;
				this.items.fileNo = this.ocrTemplate.fileNo;
				
				// Step 2: OCR 파일 정보 조회
				const fileInfoResponse = await axios.post(
					this.config.contextRoot + "/common/file/selectFileInfo.do",
					{fileNo: this.items.fileNo}
				);
				this.ocrFile = fileInfoResponse.data.fileInfo;
				
				this.fileName = this.ocrFile.fileName;
				
				const fileData = {
					fileNo: this.ocrFile.fileNo,
					fileGroupNo: this.ocrFile.fileGroupNo,
					serverFileSaveName: this.ocrFile.serverFileSaveName
				};
				
				const pdfResponse = await axios.post(
					this.config.contextRoot + "/common/file/convertPdfToPng.do",
					fileData
				);
				
				this.imageInfo.imageUrl = pdfResponse.data.imagePreview;
				this.imageInfo.imageWidth = pdfResponse.data.imageWidth;
				this.imageInfo.imageHeight = pdfResponse.data.imageHeight;
				this.isDrawImage = true;
				
				// Step 3: OCR 필드 리스트 조회
				const ocrFieldResponse = await axios.post(
					this.config.contextRoot + "/ocr/field/selectList.do",
					this.items
				);
				
				this.ocrFieldList = ocrFieldResponse.data.ocrFieldList;
				this.ocrFieldListLength = this.ocrFieldList.length;
				
				// Step 4 : OCR 필드 리스트 정보 설정
				const ocrFieldList = ocrFieldResponse.data.ocrFieldList || [];
				const updatedOcrFieldList = [];
				for (const field of ocrFieldList) {
					// ocrFieldType 속성 추가
					let ocrFieldType = field.fieldType ? field.fieldType : 'divided';
					
					if (ocrFieldType !== 'divided') {
						// ocrFieldType이 check라면 options 구성
						if (ocrFieldType === 'check') {
							const fieldOptionsResponse = await axios.post(
								this.config.contextRoot + "/field/select/fieldOptions.do",
								{fieldNo: field.fieldNo}
							);
							const fieldOptions = fieldOptionsResponse.data.fieldOptions;
							let options = [];
							let checkOptions = [];
							let checkValues = [];
							if(fieldOptions.fieldTypeCd === '03') {
								checkOptions = fieldOptions.radioOptionsLabel.split(';');
								checkValues = fieldOptions.radioOptionsValue.split(';');
							}
							else if(fieldOptions.fieldTypeCd === '04') {
								checkOptions = fieldOptions.checkboxOptionsLabel.split(';');
								checkValues = fieldOptions.checkboxOptionsValue.split(';');
							}
							else if(fieldOptions.fieldTypeCd === '05') {
								checkOptions = fieldOptions.selectOptionsLabel.split(';');
								checkValues = fieldOptions.selectOptionsValue.split(';');
							}
							checkValues.forEach((checkValue, index) => {
								options.push({
									checkOption: checkOptions[index],
									checkValue: checkValue
								});
							});
							field.checkOptions = options;
						}
						
						// area 객체 구성
						const area = {
							x: parseFloat(field.areaX) || 0,
							y: parseFloat(field.areaY) || 0,
							width: parseFloat(field.areaWidth) || 0,
							height: parseFloat(field.areaHeight) || 0
						};
						
						// position 배열 구성
						const position = [
							parseFloat(field.topLeftX) || 0,
							parseFloat(field.topLeftY) || 0,
							parseFloat(field.bottomRightX) || 0,
							parseFloat(field.bottomRightY) || 0
						];
						
						// 페이지 정보 추출
						const pageInfo = this.pageList.find(page => page.pageNo === field.pageNo);
						if (pageInfo && !this.selectedPageList.some(p => p.pageNo === pageInfo.pageNo)) {
							this.selectedPageList.push(pageInfo);
						}
						
						// 필드 이름 설정
						updatedOcrFieldList.push({
							...field,
							ocrFieldType,
							area,
							position,
							pageName: pageInfo ? pageInfo.pageName : ''
						});
					}
					else {
						const dividedFieldList = [];
						for (const fieldItem of field) {
							
							// area 객체 구성
							const area = {
								x: parseFloat(fieldItem.areaX) || 0,
								y: parseFloat(fieldItem.areaY) || 0,
								width: parseFloat(fieldItem.areaWidth) || 0,
								height: parseFloat(fieldItem.areaHeight) || 0
							};
							
							// position 배열 구성
							const position = [
								parseFloat(fieldItem.topLeftX) || 0,
								parseFloat(fieldItem.topLeftY) || 0,
								parseFloat(fieldItem.bottomRightX) || 0,
								parseFloat(fieldItem.bottomRightY) || 0
							];
							
							// 페이지 정보 추출
							const pageInfo = this.pageList.find(page => page.pageNo === fieldItem.pageNo);
							if (pageInfo && !this.selectedPageList.some(p => p.pageNo === pageInfo.pageNo)) {
								this.selectedPageList.push(pageInfo);
							}
							
							// 필드 이름 설정
							dividedFieldList.push({
								...fieldItem,
								ocrFieldType,
								area,
								position,
								pageName: pageInfo ? pageInfo.pageName : ''
							});
						}
						updatedOcrFieldList.push(dividedFieldList);
					}
				}
				this.ocrFieldList = updatedOcrFieldList;
				
				this.ocrFieldListLength = this.ocrFieldList.length;
				
				// 페이지 이름 설정
				this.items.pageName = this.selectedPageList
					.map(item => item.pageName)
					.join(',');
					
				// 다음 틱에서 캔버스 초기화 및 어노테이션 그리기
				this.$nextTick(() => {
					this.initializeCanvas();
				});
			}
			catch (error) {
				this.logger.error(this, "Error in selectOcrTemplate:", error);
				this.$alert("Failed to load OCR template. Please try again.", "Error", "error");
			}
			finally {
				this.$nextTick(function () {
					setTimeout(function() {
						EventBus.$emit("project-loading", false);
					}, 400);
				}.bind(this));
			}
		},
		doDuplicateCheck(ocrName) {
			this.logger.debug(this, "doDuplicateCheck(ocrName");
			if(ocrName != "" && ocrName != null && ocrName !== undefined) this.$set(this.items, "ocrName", ocrName);
			axios
				.post(this.config.contextRoot + "/ocr/duplicateCheck.do", this.items)
				.then((response) => {
					if(response.data.ocrExistCount == 0)
					{
						this.isDuplicate = false;
					}
					else
					{
						this.isDuplicate = true;
					}
				});
		},
		getProjectStateCd() {
			// project 셋팅
			axios
				.post(this.config.contextRoot + "/project/select.do", {projectNo: this.$route.params.projectNo})
				.then((response) => {
					this.projectStateCd = response.data.item.projectStateCd;
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		handleManualAdjustment() {
			this.isManualAdjustment = !this.isManualAdjustment;
			const widthColumns = document.getElementsByClassName("column-width");
			widthColumns.forEach((element) => {
				if (this.isManualAdjustment) {
					// column-width의 hide 클래스 제거
					element.classList.remove("hide");
				}
				else {
					// column-width의 hide 클래스 추가
					element.classList.add("hide");
				}
			});
		},
		getUrl(file) {
			return new Promise((resolve, reject) => {
				var reader = new FileReader();
				reader.onloadend = (e) => {
					let content = e.target.result;
					resolve(content);
				};
				reader.onerror = (e) => {
					reject(e);
				}
				reader.readAsDataURL(file);
			});
		},
		openUploader() {
			this.logger.debug(this, "openUploader()");
			this.$refs.myfile.click();
		},
		async upload(name, files) {
			this.logger.debug(this, "upload(name, files)");
			
			try {
				// 데이터 초기화
				this.fileName = "(100MB, Formats:PDF)";
				this.ocrFile = null;
				this.imageInfo.imageUrl = null;
				this.imageInfo.imageWidth = 0;
				this.imageInfo.imageHeight = 0;
				this.isDrawImage = false;
				this.ocrFieldList = [];
				this.selectedPageList = [];
				this.items.pageName = null;
				
				const fieldDeleteResponse = await axios.post(
					this.config.contextRoot + "/ocr/field/delete.do",
					this.items
				);
				
				if (fieldDeleteResponse.status !== 200) {
					throw new Error("Failed to delete existing OCR fields.");
				}
				
				const formData = new FormData();
				
				// 파일 1개 제한
				for (let idx = 0; idx < Math.min(files.length, 1); idx++) {
					formData.append(name, files[idx], files[idx].name);
					this.fileName = files[idx].name;
					this.ocrFile = files[idx];
				}
				
				// 로딩 바 표시
				EventBus.$emit("project-loading", true);
				
				// Step 1: 파일 업로드
				const response = await axios.post(this.config.contextRoot + "/common/file/upload.do", formData);
				
				// 파일 업로드 실패 시
				for (let idx = this.value.length - 1; idx >= 0; idx--) {
					this.value.pop();
				}
				
				// 파일 추가
				for (let idx = 0; idx < response.data.fileList.length; idx++) {
					this.value.push(response.data.fileList[idx]);
				}
				
				// 파일 유형 체크
				let fileType = this.value[0].fileExtensionName.toLowerCase();
				
				if (fileType !== "pdf") {
					throw new Error("Only PDF files are supported.");
				}
				
				// PDF 파일 정보 설정
				const fileData = {
					fileNo: response.data.fileList[0].fileNo,
					fileGroupNo: response.data.fileList[0].fileGroupNo,
					serverFileSaveName: response.data.fileList[0].serverFileSaveName
				};
				
				// Step 2: PDF 이미지 변환
				const pdfResponse = await axios.post(
					this.config.contextRoot + "/common/file/convertPdfToPng.do", 
					fileData
				);
				
				if (pdfResponse.data.error) {
					throw new Error("Documents with more than 1 page are not supported.");
				}
				
				// 이미지 정보 설정
				this.imageInfo.imageUrl = pdfResponse.data.imagePreview;
				this.imageInfo.imageWidth = pdfResponse.data.imageWidth;
				this.imageInfo.imageHeight = pdfResponse.data.imageHeight;
				this.isDrawImage = true;
				
				// Step 3: 나중에 OCR 정보 걷어낼 용도
				const ocrVo = {
					fileList: response.data.fileList,
				}
				const ocrFileResponse = await axios.post(this.config.contextRoot + "/ocr/insertFile.do", ocrVo);
				
				if (ocrFileResponse.error) {
					throw new Error("Error occurred while inserting OCR file.");
				}
				
				this.items.fileNo = ocrFileResponse.data.fileNo;
				
				// Step 3: OCR 정보 추출
				const ocrFormData = new FormData();
				ocrFormData.append("file", this.ocrFile);
				ocrFormData.append("params", JSON.stringify({
					"pages": [], 
					"pre_process": {
						"rotation_90n": false, 
						"rotation_fine": false
					}
				}));
				
				const ocrResponse = await axios.post(
					this.config.contextRoot + "/lomin/api/v1/parsing", 
					ocrFormData, 
					{
						headers: {
							accept: "application/json",
							"Content-Type": "multipart/form-data"
						}
					}
				);
				
				this.logger.debug(this, "OCR Response:", ocrResponse.data);
				
				// OCR 데이터 설정
				this.parsedData = ocrResponse.data;
				console.log(ocrResponse.data);
				
				if (this.parsedData)
				{
					const parsedTexts = this.parsedData.parsed_result[0].texts[0].text;
					console.log(parsedTexts);
				}
				
			} catch (error) {
				if (error.message === "Only PDF files are supported.") {
					this.$alert(error.message, "Warning", "warning");
					this.fileName = "(100MB, Formats:PDF)";
				}
				else if (error.message === "Documents with more than 1 page are not supported.") {
					this.$alert(error.message, "Warning", "warning");
				}
				else {
					this.exceptionHandler(this, error);
				}
			} finally {
				EventBus.$emit("project-loading", false);
			}
		},
		async processDividedFieldOCR(ocrFieldItem) {
			this.logger.debug(this, "processDividedFieldOCR()");
			
			if (!ocrFieldItem || !ocrFieldItem.length || ocrFieldItem.length !== 2) {
				this.logger.error(this, "Invalid divided field structure");
				return;
			}
			
			try {
				EventBus.$emit("project-loading", true);
				
				// A영역과 B영역의 좌표 계산
				const baseArea = ocrFieldItem[0].area;
				if (!baseArea) {
					this.logger.error(this, "No area defined for divided field");
					return;
				}
				
				// A영역 (왼쪽 절반)
				const areaA = {
					x: baseArea.x,
					y: baseArea.y,
					width: baseArea.width / 2,
					height: baseArea.height
				};
				
				// B영역 (오른쪽 절반)
				const areaB = {
					x: baseArea.x + baseArea.width / 2,
					y: baseArea.y,
					width: baseArea.width / 2,
					height: baseArea.height
				};
				
				// A영역 OCR 처리
				const ocrResultA = await this.performOCRForArea(areaA);
				if (ocrResultA) {
					this.$set(ocrFieldItem[0], 'ocrResult', ocrResultA);
				}
				
				// B영역 OCR 처리
				const ocrResultB = await this.performOCRForArea(areaB);
				if (ocrResultB) {
					this.$set(ocrFieldItem[1], 'ocrResult', ocrResultB);
				}
				
				this.logger.debug(this, "Divided OCR Results:", {
					areaA: ocrResultA,
					areaB: ocrResultB
				});
				
			} catch (error) {
				console.error("Error processing divided field OCR:", error);
				this.exceptionHandler(this, error);
			} finally {
				EventBus.$emit("project-loading", false);
			}
		},
		async performOCRForArea(area) {
			this.logger.debug(this, "performOCRForArea()", area);
			
			try {
				// Canvas에서 특정 영역만 추출
				const canvas = this.$refs.drawingCanvas;
				if (!canvas) return null;
				
				const tempCanvas = document.createElement('canvas');
				const tempContext = tempCanvas.getContext('2d');
				
				tempCanvas.width = area.width;
				tempCanvas.height = area.height;
				
				// 원본 캔버스에서 해당 영역만 복사
				tempContext.drawImage(
					canvas,
					area.x, area.y, area.width, area.height,
					0, 0, area.width, area.height
				);
				
				// Canvas를 Blob으로 변환
				return new Promise((resolve) => {
					tempCanvas.toBlob(async (blob) => {
						try {
							// OCR API 호출을 위한 FormData 생성
							const formData = new FormData();
							formData.append("file", blob, "area.png");
							formData.append("params", JSON.stringify({
								"pages": [], 
								"pre_process": {
									"rotation_90n": false, 
									"rotation_fine": false
								}
							}));
							
							const response = await axios.post(
								this.config.contextRoot + "/lomin/api/v1/parsing", 
								formData, 
								{
									headers: {
										accept: "application/json",
										"Content-Type": "multipart/form-data"
									}
								}
							);
							
							if (response.data && response.data.parsed_result && 
								response.data.parsed_result[0] && 
								response.data.parsed_result[0].texts && 
								response.data.parsed_result[0].texts[0]) {
								resolve(response.data.parsed_result[0].texts[0].text);
							} else {
								resolve("");
							}
						} catch (error) {
							console.error("OCR API error:", error);
							resolve("");
						}
					}, 'image/png');
				});
			} catch (error) {
				console.error("Error in performOCRForArea:", error);
				return "";
			}
		},
		openPageSelectModal(ocrFieldType) {
			this.logger.debug(this, "openPageSelectModal()");
			if (!this.isDrawImage) {
				this.$alert("Please upload a PDF file first.", "Warning", "warning");
				return;
			}
			this.ocrFieldType = ocrFieldType;
			this.isOcrPageSelect = true;
		},
		openPageViewModal(pageInfo) {
			this.logger.debug(this, "openPageViewModal()", pageInfo.pageNo);
			this.isOcrPageSelect = false;
			this.selectPage(pageInfo.pageNo);
			if (pageInfo) {
				if (!this.selectedPageList.some(item => item.pageNo === pageInfo.pageNo)) {
					this.selectedPageList.push(pageInfo);
				}
				
				if (this.selectedPageList.length > 0) {
					this.items.pageName = this.selectedPageList
						.map(item => item.pageName)
						.join(',');
				}
			}
		},
		async selectPage(pageNo) {
			this.logger.debug(this, "selectPage()");
			this.paramSigleCreate = {
				pageNo: pageNo,
				pdfYn: 'N',
				ocrFieldType: this.ocrFieldType,
			};
			
			if (this.ocrFieldType == "check") {
				const response = await axios.post(
					this.config.contextRoot + "/screening/selectProcList.do",
					this.paramSigleCreate
				);
				const tableDataList = response.data.tableDataList;
				
				const isOcrPageType = tableDataList.some(tableData => Object.keys(tableData).some(key => tableData[key].field && tableData[key].field.fieldList.some(field => ["03", "04", "05"].includes(field.fieldTypeCd))));
				
				if (!isOcrPageType) {
					this.$alert("The selected page does not contain any OCR fields.", "Warning", "warning");
					return;
				}
				else {
					this.isOcrPageView = true;
				}
			}
			else {
				this.isOcrPageView = true;
			}
		},
		ocrFieldSave(ocrFieldList) {
			this.logger.debug(this, "ocrFieldSave()");
			if (!this.ocrFieldList) {
				this.ocrFieldList = [];
			}
			const ocrFieldArray = [];
			if (this.ocrFieldType !== "divided") {
				for (const newField of ocrFieldList) {
					const existingIndex = this.ocrFieldList.findIndex(field => field.fieldName === newField.fieldName && field.pageNo === newField.pageNo);
					if (existingIndex !== -1) {
						// this.$alert(`Field "${newField.fieldName}" already exists. \n The existing field will be maintained.`, "Warning", "warning");
						this.$nextTick(() => {
							this.drawExistingAnnotations();
						});
					}
					else {
						this.$set(newField, 'ocrFieldType', this.ocrFieldType);
						const pageInfo = this.selectedPageList.find(item => item.pageNo === newField.pageNo);
						if (pageInfo) {
							newField.pageName = pageInfo.pageName;
						}
						const fieldNo = newField.fieldNo;
						
						if(this.ocrFieldType == "check") {
							axios.post(
								this.config.contextRoot + "/field/select/fieldOptions.do",
								{
									fieldNo: fieldNo,
								}
							).then(response => {
								const fieldOptions = response.data.fieldOptions;
								let options = [];
								let checkOptions = [];
								let checkValues = [];
								if(fieldOptions.fieldTypeCd === '03') {
									checkOptions = fieldOptions.radioOptionsLabel.split(';');
									checkValues = fieldOptions.radioOptionsValue.split(';');
								}
								else if(fieldOptions.fieldTypeCd === '04') {
									checkOptions = fieldOptions.checkboxOptionsLabel.split(';');
									checkValues = fieldOptions.checkboxOptionsValue.split(';');
								}
								else if(fieldOptions.fieldTypeCd === '05') {
									checkOptions = fieldOptions.selectOptionsLabel.split(';');
									checkValues = fieldOptions.selectOptionsValue.split(';');
								}
								checkValues.forEach((checkValue, index) => {
									options.push({
										checkOption: checkOptions[index],
										checkValue: checkValue,
									})
								})
								newField.checkOptions = options;
							}).catch(error => {
								this.exceptionHandler(this, error);
							})
						}
						this.ocrFieldList.push(newField);
					}
				}
			}
			else {
				const ocrField = [];
				ocrFieldList.forEach(field => {
					ocrField.push(field);
				})
				
				for(const field of ocrField) {
					const existingIndex = this.ocrFieldList.findIndex(item => item.fieldName === field.fieldName && item.pageNo === field.pageNo);
					if (existingIndex !== -1) {
						this.$alert(`Field "${field.fieldName}" already exists. \n The existing field will be maintained.`, "Warning", "warning");
						this.$nextTick(() => {
							this.drawExistingAnnotations();
						});
					}
					else {
						this.$set(field, 'ocrFieldType', this.ocrFieldType);
						const pageInfo = this.selectedPageList.find(item => item.pageNo === field.pageNo);
						if (pageInfo) {
							field.pageName = pageInfo.pageName;
						}
						ocrFieldArray.push(field);
					}
				}
				this.ocrFieldList.push(ocrFieldArray);
			}
		},
		deleteOcrField(idx) {
			this.logger.debug(this, "deleteOcrField()", idx);
			
			const field = this.ocrFieldList[idx];
			if (field) {
				const pageInfo = this.selectedPageList.find(item => item.pageNo === field.pageNo);
				if (pageInfo) {
					this.selectedPageList.splice(this.selectedPageList.indexOf(pageInfo), 1);
					
					this.items.pageName = this.selectedPageList
						.map(item => item.pageName)
						.join(',');
				}
			}
			
			if (this.ocrFieldList && this.ocrFieldList.length > 0) {
				this.ocrFieldList.splice(idx, 1);
			}
			
			this.deselectOcrField();
		},
		updateFieldName(ocrFieldItem) {
			this.logger.debug(this, "updateFieldName()", ocrFieldItem);
			const index = this.ocrFieldList.findIndex(field => field.fieldName === ocrFieldItem.fieldName);
			if (index !== -1) {
				this.$set(this.ocrFieldList, index, ocrFieldItem);
			}
		},
		initializeCanvas() {
			this.logger.debug(this, "initializeCanvas()");
			
			// 이미 초기화되었다면 반복 작업 방지
			if (this.isInit) {
				return;
			}
			
			// 이미지 로드 전에 isInit 플래그를 true로 설정하여 중복 실행 방지
			this.isInit = true;
			
			setTimeout(() => {
				const canvas = this.$refs.drawingCanvas;
				const container = this.$refs.imageViewer;
				if (canvas && container) {
					const img = new window.Image();
					img.onload = () => {
						canvas.width = this.imageInfo.imageWidth;
						canvas.height = this.imageInfo.imageHeight;
						this.imageObj = img;
						this.drawImageAndAnnotations();
						
						// 초기화 이후에 한 번만 실행되도록 함
						this.$nextTick(() => {
							this.drawInitAnnotations();
						});
					}
					img.src = this.imageInfo.imageUrl;
				}
			}, 1500);
		},
		drawInitAnnotations() {
			this.logger.debug(this, "drawInitAnnotations()");
			const canvas = this.$refs.drawingCanvas;
			if (!canvas || !this.imageObj) return;
			
			const context = canvas.getContext('2d');
			context.clearRect(0, 0, canvas.width, canvas.height);
			context.drawImage(this.imageObj, 0, 0, canvas.width, canvas.height);
			
			if (this.ocrFieldList && this.ocrFieldList.length > 0) {
				this.ocrFieldList.forEach((field) => {
					if (field.ocrFieldType) {
						if (field.area && field.area.width > 0 && field.area.height > 0) {
							const isActive = this.selectedOcrField && this.selectedOcrField.fieldName === field.fieldName && this.selectedOcrField.pageNo === field.pageNo;
							
							switch (field.ocrFieldType || field.fieldType) {
								case 'square':
									this.drawFieldSquare(context, field, isActive);
									break;
								case 'check':
									this.drawFieldCheck(context, field, isActive);
									break;
								default:
									this.drawFieldSquare(context, field, isActive);
									break;
							}
						}
					}
					else if (Array.isArray(field) && field.length > 0 && field[0].ocrFieldType === 'divided') {
						const isActive = this.selectedOcrField && this.selectedOcrField.fieldName === field[0].fieldName && this.selectedOcrField.pageNo === field[0].pageNo;
						
						this.drawFieldDivided(context, field, isActive);
					}
				});
			}
		},
		drawImageAndAnnotations() {
			this.logger.debug(this, "drawImageAndAnnotations()");
			const canvas = this.$refs.drawingCanvas;
			if (!canvas || !this.imageObj) return;
			const ctx = canvas.getContext('2d');
			ctx.clearRect(0, 0, canvas.width, canvas.height);
			ctx.drawImage(this.imageObj, 0, 0, canvas.width, canvas.height);
		},
		selectOcrField(ocrFieldItem) {
			this.logger.debug(this, "selectOcrField()", ocrFieldItem);
			
			if (this.selectedOcrField && this.selectedOcrField.fieldName === ocrFieldItem.fieldName && this.selectedOcrField.pageNo === ocrFieldItem.pageNo) {
				if (this.isDrawingMode) {
					this.cancelDrawing();
					return;
				}
			}
			
			this.selectedOcrField = ocrFieldItem;
			
			if (ocrFieldItem.checkOptions) {
				if (ocrFieldItem.checkValue == '') {
					this.$alert("Please select a value for \"" + ocrFieldItem.fieldName + "\"", "Info", "info");
					return;
				}
			}
			
			if(ocrFieldItem.area) {
				if (this.selectedOcrField.isFocused && this.selectedOcrField.fieldName === ocrFieldItem.fieldName && this.selectedOcrField.pageNo === ocrFieldItem.pageNo) {
					this.deselectOcrField();
					return;
				}
				else {
					this.offFocus();
					this.focusOnArea(ocrFieldItem);
				}
			}
			else {
				this.isDrawingMode = true;
				this.toolsPosition = {
					x: 0,
					y: 0,
					visible: true
				}
				this.$alert(`Please draw a rectangle on the PDF for "${ocrFieldItem.fieldName}"`, "Info", "info");
			}
			
			// this.drawExistingAnnotations();
		},
		selectOcrDividedField(ocrFieldList) {
			this.logger.debug(this, "selectOcrDividedField()", ocrFieldList);
			
			for(const ocrFieldItem of ocrFieldList) {
				if (this.selectedOcrField && this.selectedOcrField.fieldName === ocrFieldItem.fieldName && this.selectedOcrField.pageNo === ocrFieldItem.pageNo) {
					if(this.isDrawingMode) {
						this.cancelDrawing();
						return;
					}
				}
			}
			
			this.selectedOcrField = ocrFieldList;
			
			for(const ocrFieldItem of ocrFieldList) {
				if(ocrFieldItem.area) {
					if (this.selectedOcrField.isFocused && this.selectedOcrField.fieldName === ocrFieldItem.fieldName && this.selectedOcrField.pageNo === ocrFieldItem.pageNo) {
						this.deselectOcrField();
						return;
					}
					else {
						this.offFocus();
						this.focusOnArea(ocrFieldItem);
					}
				}
				else {
					this.isDrawingMode = true;
					this.toolsPosition = {
						x: 0,
						y: 0,
						visible: true
					}
				}
			}
			
			this.$alert(`Please draw a rectangle on the PDF for "${ocrFieldList[0].fieldName} / ${ocrFieldList[1].fieldName}"`, "Info", "info");
		},
		cancelDrawing() {
			const canvas = this.$refs.drawingCanvas;
			const context = canvas.getContext('2d');
			context.clearRect(0, 0, canvas.width, canvas.height);
			
			this.isDrawingMode = false;
			this.rectangle = null;
			
			this.drawExistingAnnotations();
		},
		focusOnArea(ocrFieldItem) {
			if (!this.$refs.drawingCanvas) {
				this.initializeCanvas();
				return;
			}
			
			const ocrFieldType = ocrFieldItem.ocrFieldType ? ocrFieldItem.ocrFieldType : ocrFieldItem[0].ocrFieldType;
			this.isDrawingMode = false;
			this.isEditMode = false;
			if (ocrFieldType !== "divided") {
				this.selectedOcrField.isFocused = true;
			}
			else {
				const selectedOcrFieldList = this.selectedOcrField;
				for (const ocrFieldItem of selectedOcrFieldList) {
					ocrFieldItem.isFocused = true;
				}
			}
			
			this.drawExistingAnnotations();
			if (!ocrFieldItem.area) return;
		},
		drawFieldSquare(context, field, isActive) {
			const { x, y, width, height } = field.area;
			context.strokeStyle = isActive ? 'rgba(255, 0, 0, 0.3)' : 'rgba(43, 173, 224, 0.3)';
			context.lineWidth = 2;
			context.strokeRect(x, y, width, height);
			context.fillStyle = isActive ? 'rgba(255, 0, 0, 0.3)' : 'rgba(43, 173, 224, 0.3)';
			context.fillRect(x, y, width, height);
			context.fillStyle = isActive ? 'rgba(255, 0, 0, 0.7)' : 'rgba(43, 173, 224, 0.7)';
			context.fillRect(x, y - 50, field.fieldName.length * 40, 50);
			context.font = '24px Pretendard';
			context.fillStyle = 'rgba(255, 255, 255, 0.8)';
			context.fillText(field.fieldName, x + 35, y - 20);
		},
		drawFieldDivided(context, field, isActive) {
			const { x, y, width, height } = field[0].area;
			context.strokeStyle = isActive ? 'rgba(255, 0, 0, 0.3)' : 'rgba(43, 173, 224, 0.3)';
			context.lineWidth = 2;
			context.strokeRect(x, y, width, height);
			context.fillStyle = isActive ? 'rgba(255, 0, 0, 0.3)' : 'rgba(43, 173, 224, 0.3)';
			context.fillRect(x, y, width, height);
			
			context.beginPath();
			context.moveTo(x + width / 2, y);
			context.lineTo(x + width / 2, y + height);
			context.strokeStyle = isActive ? 'rgba(255, 0, 0, 0.3)' : 'rgba(43, 173, 224, 0.3)';
			context.lineWidth = 2;
			context.stroke();
			
			context.font = '24px Pretendard bold';
			context.fillStyle = 'rgba(43, 173, 224, 0.8)';
			context.textAlign = 'center';
			context.textBaseline = 'middle';
			context.fillText('A', x + width / 4, y + height / 2);
			context.fillText('B', x + (width * 3) / 4, y + height / 2);
			
			// 필드 이름 라벨 추가 (A/B 필드명 모두 표시)
			const fieldNameA = field[0].fieldName;
			const fieldNameB = field[1].fieldName;
			const labelText = `${fieldNameA} / ${fieldNameB}`;
			
			context.fillStyle = isActive ? 'rgba(255, 0, 0, 0.7)' : 'rgba(43, 173, 224, 0.7)';
			context.fillRect(x, y - 50, labelText.length * 20, 50);
			context.font = '24px Pretendard';
			context.fillStyle = 'rgba(255, 255, 255, 0.8)';
			context.textAlign = 'left';
			context.fillText(labelText, x + 15, y - 20);
		},
		drawFieldCheck(context, field, isActive) {
			const { x, y, width, height } = field.area;
			context.strokeStyle = isActive ? 'rgba(255, 0, 0, 0.3)' : 'rgba(43, 173, 224, 0.3)';
			context.lineWidth = 2;
			context.strokeRect(x, y, width, height);
			context.fillStyle = isActive ? 'rgba(255, 0, 0, 0.3)' : 'rgba(43, 173, 224, 0.3)';
			context.fillRect(x, y, width, height);
			
			const checkWidth = width * 0.7;
			const checkHeight = height * 0.5;
			const checkX = x + width * 0.15;
			const checkY = y + height * 0.5;
			
			context.beginPath();
			context.moveTo(checkX, checkY);
			context.lineTo(checkX + checkWidth * 0.3, checkY + checkHeight * 0.8);
			context.lineTo(checkX + checkWidth, checkY - checkHeight * 0.8);
			context.lineWidth = 4;
			context.strokeStyle = isActive ? 'rgba(255, 0, 0, 0.9)' : 'rgba(43, 173, 224, 0.9)';
			context.stroke();
			
			context.fillStyle = isActive ? 'rgba(255, 0, 0, 0.7)' : 'rgba(43, 173, 224, 0.7)';
			context.fillRect(x, y - 50, field.fieldName.length * 40, 50);
			context.font = '24px Pretendard';
			context.fillStyle = 'rgba(255, 255, 255, 0.8)';
			context.fillText(field.fieldName, x + 15, y - 20);
		},
		drawExistingAnnotations() {
			this.logger.debug(this, "drawExistingAnnotations()");
			const canvas = this.$refs.drawingCanvas;
			if (!canvas || !this.imageObj) return;
			
			const context = canvas.getContext('2d');
			context.clearRect(0, 0, canvas.width, canvas.height);
			context.drawImage(this.imageObj, 0, 0, canvas.width, canvas.height);
			
			if (this.ocrFieldList) {
				this.ocrFieldList.forEach((field, index) => {
					if(field.ocrFieldType){
						if (field.area) {
							const isActive = this.selectedOcrField && this.selectedOcrField.fieldName === field.fieldName && this.selectedOcrField.pageNo === field.pageNo;
							const { x, y, width, height } = field.area;
							if (field.ocrFieldType === 'square') {
								context.strokeStyle = isActive ? 'rgba(255, 0, 0, 0.3)' : 'rgba(43, 173, 224, 0.3)';
								context.lineWidth = 2;
								context.strokeRect(x, y, width, height);
								context.fillStyle = isActive ? 'rgba(255, 0, 0, 0.3)' : 'rgba(43, 173, 224, 0.3)';
								context.fillRect(x, y, width, height);
								context.fillStyle = isActive ? 'rgba(255, 0, 0, 0.7)' : 'rgba(43, 173, 224, 0.7)';
								context.fillRect(x, y - 50, field.fieldName.length * 40, 50);
								context.font = '24px Pretendard';
								context.fillStyle = 'rgba(255, 255, 255, 0.8)';
								context.fillText(field.fieldName, x + 15, y - 20);
							}
							else if (field.ocrFieldType === 'check') {
								context.strokeStyle = isActive ? 'rgba(255, 0, 0, 0.3)' : 'rgba(43, 173, 224, 0.3)';
								context.lineWidth = 2;
								context.strokeRect(x, y, width, height);
								context.fillStyle = isActive ? 'rgba(255, 0, 0, 0.3)' : 'rgba(43, 173, 224, 0.3)';
								context.fillRect(x, y, width, height);
								
								const checkWidth = width * 0.7;
								const checkHeight = height * 0.5;
								const checkX = x + width * 0.15;
								const checkY = y + height * 0.5;
								
								context.beginPath();
								context.moveTo(checkX, checkY);
								context.lineTo(checkX + checkWidth * 0.3, checkY + checkHeight * 0.8);
								context.lineTo(checkX + checkWidth, checkY - checkHeight * 0.8);
								context.lineWidth = 4;
								context.strokeStyle = isActive ? 'rgba(255, 0, 0, 0.9)' : 'rgba(43, 173, 224, 0.9)';
								context.stroke();
								
								context.fillStyle = isActive ? 'rgba(255, 0, 0, 0.7)' : 'rgba(43, 173, 224, 0.7)';
								context.fillRect(x, y - 50, field.fieldName.length * 40, 50);
								context.font = '24px Pretendard';
								context.fillStyle = 'rgba(255, 255, 255, 0.8)';
								context.fillText(field.fieldName, x + 15, y - 20);
							}
						}
					}
					else {
						const ocrFieldList = this.ocrFieldList[index];
						for (let idx = 0; idx < 1; idx++) {
							const ocrFieldItem = ocrFieldList[idx];
							if (ocrFieldItem.area) {
								const isActive = (this.selectedOcrField && this.selectedOcrField.length > 1) && this.selectedOcrField[idx].fieldName === ocrFieldItem.fieldName && this.selectedOcrField[idx].pageNo === ocrFieldItem.pageNo;
								const { x, y, width, height } = ocrFieldItem.area;
								
								context.strokeStyle = isActive ? 'rgba(255, 0, 0, 0.3)' : 'rgba(43, 173, 224, 0.3)';
								context.lineWidth = 2;
								context.strokeRect(x, y, width, height);
								context.fillStyle = isActive ? 'rgba(255, 0, 0, 0.3)' : 'rgba(43, 173, 224, 0.3)';
								context.fillRect(x, y, width, height);
								
								context.beginPath();
								context.moveTo(x + width / 2, y);
								context.lineTo(x + width / 2, y + height);
								context.strokeStyle = isActive ? 'rgba(255, 0, 0, 0.3)' : 'rgba(43, 173, 224, 0.3)';
								context.lineWidth = 2;
								context.stroke();
								
								context.font = '24px Pretendard bold';
								context.fillStyle = 'rgba(43, 173, 224, 0.9)';
								context.textAlign = 'center';
								context.textBaseline = 'middle';
								context.fillText('A', x + width / 4, y + height / 2);
								context.fillText('B', x + (width * 3) / 4, y + height / 2);
								
								// divided 필드의 A/B 필드명 모두 표시
								const fieldNameA = ocrFieldList[0].fieldName;
								const fieldNameB = ocrFieldList[1].fieldName;
								const labelText = `${fieldNameA} / ${fieldNameB}`;

								context.fillStyle = isActive ? 'rgba(255, 0, 0, 0.7)' : 'rgba(43, 173, 224, 0.7)';
								context.fillRect(x, y - 50, labelText.length * 20, 50);
								context.font = '24px Pretendard';
								context.fillStyle = 'rgba(255, 255, 255, 0.8)';
								context.textAlign = 'left';
								context.fillText(labelText, x + 15, y - 20);
							}
						}
					}
				});
			}
		},
		deselectOcrField() {
			if (this.isDrawingMode) {
				this.cancelDrawing();
			}
			this.offFocus();
			this.selectedOcrField.isFocused = false;
			this.selectedOcrField = null;
			this.toolsPosition = {
				x: 0,
				y: 0,
				visible: false
			}
			this.drawExistingAnnotations();
		},
		offFocus() {
			this.logger.debug(this, "offFocus()");
			this.ocrFieldList.forEach((field) => {
				if (field.isFocused) {
					field.isFocused = false;
				}
			});
		},
		startDrawing(event) {
			if (!this.selectedOcrField || !this.isDrawingMode) return;
			
			this.isDrawing = true;
			const canvas = this.$refs.drawingCanvas;
			const rect = canvas.getBoundingClientRect();
			
			const scaleX = canvas.width / rect.width;
			const scaleY = canvas.height / rect.height;
			
			this.startX = (event.clientX - rect.left) * scaleX;
			this.startY = (event.clientY - rect.top) * scaleY;
			
			this.rectangle = {
				x: this.startX,
				y: this.startY, 
				width: 0, 
				height: 0,
				type: this.selectedOcrField.ocrFieldType ? this.selectedOcrField.ocrFieldType : this.selectedOcrField[0].ocrFieldType // 타입 정보 저장
			};
		},
		draw(event) {
			if (!this.isDrawing || !this.isDrawingMode || !this.selectedOcrField || !this.rectangle) return;
			
			const canvas = this.$refs.drawingCanvas;
			const context = canvas.getContext('2d');
			const rect = canvas.getBoundingClientRect();
			
			const scaleX = canvas.width / rect.width;
			const scaleY = canvas.height / rect.height;
			
			const currentX = (event.clientX - rect.left) * scaleX;
			const currentY = (event.clientY - rect.top) * scaleY;
			
			context.clearRect(0, 0, canvas.width, canvas.height);
			this.drawExistingAnnotations();
			
			this.rectangle.width = currentX - this.startX;
			this.rectangle.height = currentY - this.startY;
			
			this.toolsPosition = {
				x: (this.rectangle.x + this.rectangle.width) / scaleX + 80,
				y: (this.rectangle.y + this.rectangle.height / 2) / scaleY,
				visible: true
			};
			
			// 저장된 타입에 따라 그리기 (미리 저장된 타입을 사용하여 분기 최소화)
			switch (this.rectangle.type) {
				case 'square':
					this.drawSquareShape(context);
					break;
				case 'divided':
					this.drawDividedShape(context);
					break;
				case 'check':
					this.drawCheckShape(context);
					break;
				default:
					this.drawSquareShape(context);
			}
		},
		drawSquareShape(context) {
			context.strokeStyle = 'rgba(43, 173, 224, 0.8)';
			context.lineWidth = 2;
			context.strokeRect(this.rectangle.x, this.rectangle.y, this.rectangle.width, this.rectangle.height);
			context.fillStyle = 'rgba(43, 173, 224, 0.3)';
			context.fillRect(this.rectangle.x, this.rectangle.y, this.rectangle.width, this.rectangle.height);
			
			// 필드 이름 라벨
			context.fillStyle = 'rgba(43, 173, 224, 0.7)';
			context.fillRect(this.rectangle.x, this.rectangle.y-50, this.selectedOcrField.fieldName.length * 40, 50);
			context.font = '32px Pretendard';
			context.fillStyle = 'rgba(255, 255, 255, 0.8)';
			context.fillText(this.selectedOcrField.fieldName, this.rectangle.x + 35, this.rectangle.y - 20);
		},
		drawDividedShape(context) {
			// 전체 사각형 그리기
			context.strokeStyle = 'rgba(43, 173, 224, 0.8)';
			context.lineWidth = 2;
			context.strokeRect(this.rectangle.x, this.rectangle.y, this.rectangle.width, this.rectangle.height);
			context.fillStyle = 'rgba(43, 173, 224, 0.3)';
			context.fillRect(this.rectangle.x, this.rectangle.y, this.rectangle.width, this.rectangle.height);
			
			// 중앙 분리선 그리기
			context.beginPath();
			context.moveTo(this.rectangle.x + this.rectangle.width / 2, this.rectangle.y);
			context.lineTo(this.rectangle.x + this.rectangle.width / 2, this.rectangle.y + this.rectangle.height);
			context.strokeStyle = 'rgba(43, 173, 224, 0.8)';
			context.lineWidth = 2;
			context.stroke();
			
			// 왼쪽 구역에 "A" 텍스트 추가
			context.font = '24px Pretendard bold';
			context.fillStyle = 'rgba(43, 173, 224, 0.9)';
			context.textAlign = 'center';
			context.textBaseline = 'middle';
			context.fillText('A', this.rectangle.x + this.rectangle.width / 4, this.rectangle.y + this.rectangle.height / 2);
			
			// 오른쪽 구역에 "B" 텍스트 추가
			context.fillText('B', this.rectangle.x + (this.rectangle.width * 3) / 4, this.rectangle.y + this.rectangle.height / 2);
			
			// 필드 이름 라벨 추가 (A/B 필드명 모두 표시)
			const fieldNameA = this.selectedOcrField[0].fieldName;
			const fieldNameB = this.selectedOcrField[1].fieldName;
			const labelText = `${fieldNameA} / ${fieldNameB}`;

			context.fillStyle = 'rgba(43, 173, 224, 0.7)';
			context.fillRect(this.rectangle.x, this.rectangle.y - 50, labelText.length * 20, 50);
			context.font = '24px Pretendard';
			context.fillStyle = 'rgba(255, 255, 255, 0.8)';
			context.textAlign = 'left';
			context.fillText(labelText, this.rectangle.x + 15, this.rectangle.y - 20);
		},
		drawCheckShape(context) {
			// 사각형 그리기
			context.strokeStyle = 'rgba(43, 173, 224, 0.8)';
			context.lineWidth = 2;
			context.strokeRect(this.rectangle.x, this.rectangle.y, this.rectangle.width, this.rectangle.height);
			context.fillStyle = 'rgba(43, 173, 224, 0.3)';
			context.fillRect(this.rectangle.x, this.rectangle.y, this.rectangle.width, this.rectangle.height);
			
			// 체크 표시 그리기
			const checkWidth = this.rectangle.width * 0.7;
			const checkHeight = this.rectangle.height * 0.5;
			const checkX = this.rectangle.x + this.rectangle.width * 0.15;
			const checkY = this.rectangle.y + this.rectangle.height * 0.5;
			
			context.beginPath();
			context.moveTo(checkX, checkY);
			context.lineTo(checkX + checkWidth * 0.3, checkY + checkHeight * 0.8);
			context.lineTo(checkX + checkWidth, checkY - checkHeight * 0.8);
			context.lineWidth = 4;
			context.strokeStyle = 'rgba(43, 173, 224, 0.9)';
			context.stroke();
			
			// 필드 이름 라벨
			context.fillStyle = 'rgba(43, 173, 224, 0.7)';
			context.fillRect(this.rectangle.x, this.rectangle.y-50, this.selectedOcrField.fieldName.length * 40, 50);
			context.font = '32px Pretendard';
			context.fillStyle = 'rgba(255, 255, 255, 0.8)';
			context.fillText(this.selectedOcrField.fieldName, this.rectangle.x + 15, this.rectangle.y - 20);
		},
		stopDrawing() {
			if (!this.isDrawing || !this.isDrawingMode) return;
			this.isDrawing = false;
		},
		saveDrawing() {
			if (!this.selectedOcrField || !this.rectangle) return;
			
			// 픽셀 -> OCR 좌표 변환
			const canvas = this.$refs.drawingCanvas;
			
			const x1 = this.rectangle.x / canvas.width;
			const y1 = this.rectangle.y / canvas.height;
			const x2 = (this.rectangle.x + this.rectangle.width) / canvas.width;
			const y2 = (this.rectangle.y + this.rectangle.height) / canvas.height;
			
			if (this.selectedOcrField.ocrFieldType) {
				this.$set(this.selectedOcrField, 'position', [x1, y1, x2, y2]);
				this.$set(this.selectedOcrField, 'area', {
					x: this.rectangle.x,
					y: this.rectangle.y,
					width: this.rectangle.width,
					height: this.rectangle.height
				});
			}
			else {
				const selectedOcrField = this.selectedOcrField;
				for(const ocrFieldItem of selectedOcrField) {
					this.$set(ocrFieldItem, 'position', [x1, y1, x2, y2]);
					this.$set(ocrFieldItem, 'area', {
						x: this.rectangle.x,
						y: this.rectangle.y,
						width: this.rectangle.width,
						height: this.rectangle.height
					});
				}
			}
			
			this.drawExistingAnnotations();
			
			if (this.selectedOcrField.ocrFieldType) {
				this.$alert(`Area saved for "${this.selectedOcrField.fieldName}"`, "Success", "success");
			}
			else {
				this.$alert(`Area saved for "${this.selectedOcrField[0].fieldName} / ${this.selectedOcrField[1].fieldName}"`, "Success", "success");
			}
			this.deselectOcrField();
		},
		editAnnotation(ocrFieldItem) {
			this.logger.debug(this, "editAnnotation()", ocrFieldItem);
			this.selectedOcrField = ocrFieldItem;
			this.isDrawingMode = true;
			this.isEditMode = true;
			
			this.toolsPosition = {
				x: 0,
				y: 0,
				visible: true
			}
			
			this.drawExistingAnnotations();
			
			// divided 필드인지 확인하여 적절한 메시지 표시
			if (ocrFieldItem.ocrFieldType) {
				// 단일 필드 (square, check 등)
				this.$alert(`Please redraw the area for "${ocrFieldItem.fieldName}"`, "Info", "info");
			} else {
				// divided 필드 (배열 형태)
				const fieldNameA = ocrFieldItem[0].fieldName;
				const fieldNameB = ocrFieldItem[1].fieldName;
				this.$alert(`Please redraw the area for "${fieldNameA} / ${fieldNameB}"`, "Info", "info");
			}
		},
		handleEscKey(event) {
			if (event.key === 'Escape' && this.isDrawingMode) {
				this.deselectOcrField();
			}
		},
		async doSave() {
			this.logger.debug(this, "doSave()");
			EventBus.$emit("project-loading", true);
			const formData = new FormData();
			
			// ocr template 기본 정보 검증
			if (!this.items.ocrName || !this.items.projectNo || !this.items.description) {
				const missingField = !this.items.ocrName ? "OCR name" : 
									 !this.items.projectNo ? "project" : "description";
				this.$alert(`Please enter the ${missingField}.`, "Warning", "warning");
				EventBus.$emit("project-loading", false);
				return;
			}
			
			// repeatCnt 임의 설정
			this.items.repeatCnt = 1;
			
			// ocr template name 중복 체크
			this.doDuplicateCheck();
			
			if (this.isDuplicate) {
				this.$alert("The OCR name already exists.", "Warning", "warning");
				EventBus.$emit("project-loading", false);
				return;
			}
			
			// ocrFieldList 검증
			if (this.ocrFieldList.length === 0) {
				this.$alert("Please add at least one field.", "Warning", "warning");
				EventBus.$emit("project-loading", false);
				return;
			}
			
			// 드로잉 검증
			if (this.isDrawingMode) {
				this.$alert("Please finish drawing before saving.", "Warning", "warning");
				EventBus.$emit("project-loading", false);
				return;
			}
			
			formData.append("projectNo", this.items.projectNo);
			formData.append("ocrName", this.items.ocrName);
			formData.append("description", this.items.description);
			formData.append("repeatCnt", this.items.repeatCnt);
			formData.append("fileNo", this.items.fileNo);
			
			let ocrData = {
				ocrNo: this.items.ocrNo,
				projectNo: this.items.projectNo,
				ocrName: this.items.ocrName,
				description: this.items.description,
				repeatCnt: this.items.repeatCnt,
				fileNo: this.items.fileNo,
			};
			
			try {
				// Step 1: OCR 필드 기본 정보 수정
				const ocrResponse = await axios.post(this.config.contextRoot + "/ocr/update.do", ocrData);
				
				if (ocrResponse.status !== 200) {
					throw new Error("Failed to update OCR template data");
				}
				
				// Step 2: OCR 필드 정보 삭제
				await axios.post(
					this.config.contextRoot + "/ocr/field/delete.do",
					ocrData
				)
				
				// Step 3: OCR 필드 정보 추가
				for (const field of this.ocrFieldList) {
					// 단일 필드 (square, check) 처리
					if (field.ocrFieldType) {
						// 단일 필드의 area와 position이 정의되어 있는지 확인
						if (!field.area || !field.position) {
							throw new Error(`Please draw area for field "${field.fieldName}"`);
						}
						
						const fieldData = {
							ocrNo: this.items.ocrNo,
							fieldNo: field.fieldNo,
							fieldName: field.fieldName,
							fieldType: field.fieldType || field.ocrFieldType,
							questionNo: field.questionNo,
							procFieldNo: field.procFieldNo,
							procQuestionNo: field.procQuestionNo,
							pageNo: field.pageNo,
							areaX: field.area.x,
							areaY: field.area.y,
							areaWidth: field.area.width,
							areaHeight: field.area.height,
							topLeftX: field.position[0],
							topLeftY: field.position[1],
							bottomRightX: field.position[2],
							bottomRightY: field.position[3],
							checkValue: field.checkValue,
						};
						await axios.post(this.config.contextRoot + "/ocr/field/insert.do", fieldData);
					}
					// divided 필드 (배열 형태) 처리
					else if (Array.isArray(field) && field.length > 0 && field[0].ocrFieldType === 'divided') {
						for (const ocrFieldItem of field) {
							// divided 필드의 area와 position이 정의되어 있는지 확인
							if (!ocrFieldItem.area || !ocrFieldItem.position) {
								throw new Error(`Please draw area for divided field "${ocrFieldItem.fieldName}"`);
							}
							
							const fieldData = {
								ocrNo: this.items.ocrNo,
								fieldNo: ocrFieldItem.fieldNo,
								fieldName: ocrFieldItem.fieldName,
								fieldType: ocrFieldItem.fieldType || ocrFieldItem.ocrFieldType,
								questionNo: ocrFieldItem.questionNo,
								procFieldNo: ocrFieldItem.procFieldNo,
								procQuestionNo: ocrFieldItem.procQuestionNo,
								pageNo: ocrFieldItem.pageNo,
								areaX: ocrFieldItem.area.x,
								areaY: ocrFieldItem.area.y,
								areaWidth: ocrFieldItem.area.width,
								areaHeight: ocrFieldItem.area.height,
								topLeftX: ocrFieldItem.position[0],
								topLeftY: ocrFieldItem.position[1],
								bottomRightX: ocrFieldItem.position[2],
								bottomRightY: ocrFieldItem.position[3],
								checkValue: ocrFieldItem.checkValue,
							};
							await axios.post(this.config.contextRoot + "/ocr/field/insert.do", fieldData);
						}
					}
					// 예상치 못한 필드 구조인 경우
					else {
						console.warn("Unknown field structure:", field);
						throw new Error("Invalid field structure detected");
					}
				}
				
				this.$alert("OCR template updated successfully", "Success", "success");
				
				setTimeout(() => {
					let url = this.config.contextRoot + "/project/" + this.items.projectNo + "/ocr";
					this.$router.push(url);
				}, 500);
				
			} catch (error) {
				this.$alert(error.message || "Failed to save OCR template", "Error", "error");
				console.error(error);
			} finally {
				EventBus.$emit("project-loading", false);
			}
		},
	},
}
</script>

<style scoped>
.survey-contents-contaner {
	display: grid;
	grid-template-columns: 1fr;
	grid-auto-flow: auto;
	row-gap: 0;
	position: absolute;
	top: 171px;
	left: calc(19% + 155px);
	width: calc(81% - 260px);
	height: calc(100% - 171px);
	padding: 0 0 50px 0;
	overflow-x: hidden;
	overflow-y: scroll;
	z-index: 50;
}
.control-box {
	display: flex;
	align-items: center;
	width: 100%;
	height: 35px;
	padding: 0 0 0 34px;
	background-color: #eee;
}

.table-set > input[type=number] {
	width: calc(50% - 15px);
}

.table-set > span {
	width: 30px;
	text-align: center;
}

.procedure-table {
	width: 100%;
	border-collapse: separate;
	border-spacing: 0;
}

.procedure-table:focus {
	outline: none;
}

.procedure-table tr {
	-moz-user-select: none;
	-webkit-user-select: none;
	user-select: none;
}

.procedure-table thead {
	position: sticky;
	top: 0px;
	z-index: 55;
}

.procedure-table thead th {
	position: relative;
	min-width: 30px;
	height: 35px;
	overflow-x: auto;
	resize: horizontal;
	-moz-user-select: none;
	-webkit-user-select: none;
	user-select: none;
}

.procedure-table thead tr th:first-child {
	width: 35px;
	resize: none;
	-webkit-user-select: none;
}

.procedure-table tbody th {
	width: 35px;
	position: relative;
	height: 50px;
	min-height: 50px;
	overflow-y: auto;
	resize: vertical;
	-moz-user-select: none;
	-webkit-user-select: none;
	user-select: none;
}

.procedure-table th {
	border: 1px solid #ccc;
	background-color: #eee;
	font-weight: 600;
	font-size: 10pt;
	color: #000;
}

.procedure-table td {
	position: relative;
	border: 1px solid #ccc;
	background-color: #fff;
	font-size: 10pt;
	word-break: keep-all;
}

.procedure-table td > input[type=text] {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	padding: 0 10px;
	border: none;
	background-color: unset;
	font-weight: inherit;
	font-size: inherit;
	text-align: inherit;
}

.procedure-table .focus-celltype {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	padding: 5px;
	font-family: cursive;
	font-weight: 500;
	font-size: 9pt;
	text-align: right;
	overflow: hidden;
	z-index: 5;
	opacity: 0.6;
}
.procedure-table .focus-celltype .celltype-repeat {
	display: inline-block;
	margin: 0 5px 0 0;
	padding: 2px 5px;
	background-color: #fc9e12;
	border-radius: 3px;
	color: rgb(255, 255, 255);
}

.procedure-table .focus-celltype .celltype-header {
	display: inline-block;
	margin: 0 5px 0 0;
	padding: 2px 5px;
	background-color: #2bade0;
	border-radius: 3px;
	color: #fff;
}

.procedure-table .focus-celltype .celltype-text {
	display: inline-block;
	padding: 2px 5px;
	background-color: #9ecc5a;
	border-radius: 3px;
	color: #fff;
}

.procedure-table .focus-celltype .celltype-data {
	display: inline-block;
	padding: 2px 5px;
	background-color: #cc5a5a;
	border-radius: 3px;
	color: #fff;
}
.procedure-table .focus-celltype .listIndex-data {
	display: inline-block;
	padding: 2px 5px;
	background-color: #8808af;
	margin-left: 3px;
	border-radius: 3px;
	color: #fff;
}

.unfocus-text,
.table-head {
	display: flex;
	justify-content: inherit;
	align-items: center;
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	padding: 0 10px;
	font-weight: inherit;
	font-size: 10pt;
	overflow: hidden;
	z-index: 15;
}

.table-data {
	display: flex;
	align-items: center;
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	padding: 0 10px;
	font-weight: inherit;
	font-size: 10pt;
	overflow: hidden;
	z-index: 1;
}

.survey-field-list {
	width: 100%;
	font-weight: 600 !important;
	font-size: 10pt !important;
	color: #666;
	overflow-y: visible;
}

.survey-field-vtype,
.survey-field-htype {
	max-width: 100%;
	font-weight: 400 !important;
}

.input-crud-error::placeholder {
	color: rgb(224, 91, 91);
}
.date-picker{
	position: relative;
}
.hide {
	display: none;
}
.survey-name-ocr{
	display: grid;
	grid-template-columns: 200px 1fr 200px 1fr;
	grid-template-rows: 1fr 1fr 1fr;
	top: 30px;
	width: 100%;
	height: 136px;
	border-top: 1px solid #ccc;
}
.survey-center-ocr{
	display: flex;
	min-height: calc(100% - 171px);
	height: calc(100% - 171px);
	margin-top: 30px;
}
.survey-left-ocr{
	width: 75%;
	height: 100%;
	border: 1px solid #ccc;
	border-right: none;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: #E4E4E4;
	color: #999;
	font-weight: bold;
	font-size: 25px;
	cursor: pointer;
}
.survey-right-ocr{
	width: 25%;
	height: 100%;
	border: 1px solid #ccc;
}
.field-spec-header{
	width: 100%;
	height: 50px;
	background-color: #FAFAFA;
	display: flex;
	align-items: center;
	padding-left: 20px;
	color: #2BADE0;
	font-weight: bold;
	font-size: 13px;
	border-bottom: 1px solid #ccc;
}
.field-spec-sub{
	width: 100%;
	height: 50px;
	display: flex;
	align-items: center;
	padding-left: 20px;
	font-weight: bold;
	font-size: 13px;
	color: #999999;
}
.field-type-list{
	display: flex;
	justify-content: center;
	column-gap: 10px;
	padding: 0 10px 0 10px;
}
.field-type-btn{
	flex: 1;
	height: 70px;
	background-color: #FAFAFA;
	border-radius: 4px;
	border: #E5E8EB 1px solid;
	box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
	cursor: pointer;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	row-gap: 6.5px;
	font-size: 12px;
	font-weight: bold;
	color: #CCCCCC;
}
.field-type-btn:hover{
	border: #2BADE0 1px solid;
	box-shadow: none;
	color: #2BADE0;
}
.field-type-img-1{
	width: 80%;
	height: 24px;
	background-color: #fff;
	/* border: 1px solid #707070; */
	display: flex;
	justify-content: center;
	align-items: center;
	color: #707070;
}
.field-type-img-2{
	width: 80%;
	height: 24px;
	background-color: #fff;
	border: 1px solid #707070;
	display: flex;
}
.field-type-img-3{
	width: 40%;
	height: 24px;
	background-color: #fff;
	border: 1px solid #707070;
	display: flex;
	justify-content: center;
	align-items: center;
	color: #707070;
}
.field-type-img-sub{
	width: 50%;
	height: 100%;
	background-color: #fff;
	border: 1px solid #707070;
	display: flex;
	justify-content: center;
	align-items: center;
	color: #707070;
}
.field-type-img-sub:first-child{
	border-right: none;
}
.ocr-field-list {
	width: 100%;
	display: grid;
	gap: 20px;
	margin: 20px 0;
	padding: 0 10px 0 10px;
	max-height: calc(100% - 200px);
	overflow-y: auto;
}
.ocr-field-list::-webkit-scrollbar {
	width: 20px;
}

.ocr-field-list::-webkit-scrollbar-thumb {
	float: right;
	border: 7px solid transparent;
	border-radius: 20px;
	background: linear-gradient(to top, #2bade0, #9ecc5a);
	background-clip: padding-box;
}

.ocr-field-list::-webkit-scrollbar-track {
	background-color: #fff;
}
.ocr-field-item {
	border: 1px solid #ccc;
	border-radius: 4px;
	background-color: #f4f4f4;
}
.ocr-field-item:hover {
	border-color: #2BADE0;
	box-shadow: 0 2px 5px rgba(0,0,0,0.1);
	cursor: pointer;
}
.ocr-field-item.selected {
	border: 2px solid #2BADE0;
	background-color: rgba(43, 173, 224, 0.05);
}
.ocr-field-item.selected::before {
	content: '';
	position: absolute;
	left: -10px;
	top: 50%;
	transform: translateY(-50%);
	width: 0;
	height: 0;
	border-top: 6px solid transparent;
	border-bottom: 6px solid transparent;
	border-right: 8px solid #2BADE0;
}
.ocr-field-title {
	width: 100%;
	height: 50px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0 10px;
	background-color: #FAFAFA;
	border-bottom: 1px solid #ccc;
}
.ocr-field-serial {
	font-size: 13px;
	font-weight: bold;
	color: #999;
}
.orc-field-icon {
	display: flex;
	flex-wrap: nowrap;
	gap: 1rem;
}
.ocr-field-content {
	width: 100%;
	display: grid;
	grid-template-columns: 1fr 3fr;
	gap: 10px;
	padding: 20px 10px;
}
.ocr-field-category {
	width: 100%;
	display: flex;
	justify-content: flex-start;
	align-items: center;
}
.ocr-field-text {
	font-size: 13px;
	color: #666;
}
.ocr-field-box {
	width: 100%;
}
.pdf-container {
	position: relative;
	width: 100%;
	height: 100%;
	overflow: auto;
	background-color: #f4f4f4;
}
.canvas-container {
	position: absolute;
	top: 0;
	left: 0;
	/* width: 100%; */
	/* height: 100%; */
	z-index: 10;
	pointer-events: none;
}
.canvas-container.canvas-active {
	pointer-events: auto;
}
.drawing-canvas {
	width: 100%;
	height: 100%;
	cursor: crosshair;
}
.canvas-controls {
	position: sticky;
	top: 10px;
	left: 10px;
	float: left;
	z-index: 20;
	background-color: rgba(255, 255, 255, 0.8);
	padding: 5px;
	border-radius: 5px;
	box-shadow: 0 2px 5px rgba(0,0,0,0.2);
}
.canvas-control-btn {
	padding: 5px 10px;
	background-color: #f8f8f8;
	border: 1px solid #ccc;
	border-radius: 3px;
	cursor: pointer;
	font-size: 12px;
}
.canvas-control-btn:hover {
	background-color: #efefef;
}
.drawing-tools {
	position: absolute;
	top: 10px;
	right: 10px;
	background-color: rgba(255, 255, 255, 0.8);
	float: right;
	z-index: 20;
	width: fit-content;
	display: flex;
	padding: 5px;
	border-radius: 5px;
	box-shadow: 0 2px 5px rgba(0,0,0,0.2);
}
.drawing-tool {
	width: 30px;
	height: 30px;
	margin: 0 5px;
	border: 1px solid #ccc;
	background-color: white;
	border-radius: 3px;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
}
.drawing-tool:hover {
	background-color: #f0f0f0;
}
.tool-icon {
	font-size: 18px;
	line-height: 1;
}
.save-icon {
	color: #2cb42c;
}
.cancel-icon {
	color: #ff3b3b;
}
.edit-icon {
	background-image: url("~@/assets/images/project/btn_write_survey.png");
}
.elipsis-input {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.btn-edit, .btn-delete {
    width: 24px;
    height: 24px;
    border: none;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
}

.ocr-result-text {
    background-color: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 4px;
    padding: 8px 12px;
    font-family: 'Pretendard', sans-serif;
    font-size: 14px;
    color: #495057;
    min-height: 20px;
    word-break: break-all;
    white-space: pre-wrap;
}

.ocr-result-text:empty::before {
    content: 'No OCR result yet';
    color: #6c757d;
    font-style: italic;
}
/* .btn-edit, .btn-delete {
	width: 24px;
	height: 24px;
	background-color: transparent;
	border: none;
	cursor: pointer;
	background-repeat: no-repeat;
	background-position: center;
} */
.btn-edit {
	background-image: url("~@/assets/images/project/btn_write_survey.png");
}
.btn-delete {
	background-image: url("~@/assets/images/project/btn_delete.png");
}
</style>
